import { ProgressBarItem } from 'components/ProgressBar';

export const REVIEW_STEP: ProgressBarItem = {
  type: 'single',
  title: 'Review Quote',
  active: false,
};

export const PAID_NO_FINANCE_BASE_STEPS: ProgressBarItem[] = [
  REVIEW_STEP,
  {
    type: 'single',
    title: 'Choose Payment',
    active: false,
  },
];

export const DECLINED_STEPS: ProgressBarItem[] = [
  REVIEW_STEP,
  {
    type: 'single',
    title: 'Choose Payment',
    active: false,
  },
  {
    type: 'single',
    title: 'Complete',
    active: true,
  },
];
